
class Errors {

    constructor() {
        this.errors = {};
    }

    has(field) {
        return this.errors[field];
    }

    get(field) {
        if (this.has(field)) {
            return this.errors[field][0];
        }
    }

    record(errors) {
        this.errors = errors;
    }


    clear() {
        this.errors = {};
    }

    any() {
        return Object.keys(this.errors).length > 0;
    }

    all() {
        let all = [];

        for (let key in this.errors) {
            all.push(this.errors[key][0]);
        }

        return all;
    }

    remove(field) {
        if (this.has(field)) {
            delete this.errors[field];
        }
    }
}

export {Errors as default}